import { Brain, Sparkles, Rocket, MessageCircle } from 'lucide-react';

const clusterIconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  mind: Brain,
  spark: Sparkles,
  rocket: Rocket,
  message: MessageCircle,
};

export const getClusterIcon = (key: string) => {
  return clusterIconMap[key] || Sparkles;
};
